import { useQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { currentAdminQuery } from "@/api/queries";
import { AppShell } from "@/app/layouts/app-shell";
import { Spinner } from "@/components/ui/spinner";
import { SetPasswordScreen } from "@/features/auth/change-password-form";

/** Guard: no session → /login (keeping the destination). The backend still authorizes every call. */
export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context, location }) => {
    const current = await context.queryClient.ensureQueryData(currentAdminQuery());
    if (!current) throw redirect({ to: "/login", search: { redirect: location.href } });
  },
  component: Authenticated,
});

function Authenticated() {
  const { data } = useQuery(currentAdminQuery());
  if (!data)
    return (
      <div className="flex min-h-svh items-center justify-center gap-2 text-muted-foreground" role="status">
        <Spinner /> Restoring session…
      </div>
    );
  // A temporary password must be replaced before anything else (the backend enforces it too).
  if (data.identity.mustChangePassword) return <SetPasswordScreen name={data.identity.name} />;
  return <AppShell current={data} />;
}
